"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var recorder_1 = require("./recorder");
var events_1 = require("events");
var IFlyState;
(function (IFlyState) {
    IFlyState[IFlyState["Free"] = 0] = "Free";
    IFlyState[IFlyState["Connecting"] = 1] = "Connecting";
    IFlyState[IFlyState["End"] = 2] = "End";
})(IFlyState || (IFlyState = {}));
var IFlyBase = (function (_super) {
    __extends(IFlyBase, _super);
    function IFlyBase() {
        var _this = _super.call(this) || this;
        _this.language = 'zh_cn';
        _this.init();
        return _this;
    }
    IFlyBase.prototype.check = function () {
        return this.recorder.check();
    };
    Object.defineProperty(IFlyBase.prototype, "recorder", {
        get: function () {
            return this._recorder;
        },
        set: function (value) {
            this._recorder = value;
        },
        enumerable: true,
        configurable: true
    });
    IFlyBase.prototype.start = function (isConnectIfly, language, flyType, testContent) {
        if (isConnectIfly === void 0) { isConnectIfly = true; }
        if (language === void 0) { language = 'zh_cn'; }
        if (flyType === void 0) { flyType = 'iat'; }
        if (testContent === void 0) { testContent = ''; }
        this.language = language;
        this.isSubmit = true;
        this.startRecoder();
    };
    IFlyBase.prototype.stop = function (isSubmit) {
        if (isSubmit === void 0) { isSubmit = true; }
        if (this.recorder) {
            this.recorder.stop();
        }
        clearTimeout(this.drawRecordId);
        this.reset();
    };
    IFlyBase.prototype.getPcm = function () {
        return this.recorder.getPCMBlob();
    };
    IFlyBase.prototype.init = function () {
        this.drawRecord = this.drawRecord.bind(this);
        this.recorder = new recorder_1.default({
            sampleBits: 16,
            sampleRate: 16000,
            numChannels: 1,
            compiling: false,
        });
    };
    IFlyBase.prototype.drawRecord = function () {
        this.drawRecordId = setTimeout(this.drawRecord, 40);
        var v = this.wave(this.recorder.getRecordAnalyseData());
        this.emit(IFlyBase.WAVE, v);
    };
    IFlyBase.prototype.wave = function (arr) {
        var min = arr[0];
        var max = arr[0];
        var len = arr.length;
        for (var i = 1; i < len; i++) {
            if (arr[i] < min) {
                min = arr[i];
            }
            if (arr[i] > max) {
                max = arr[i];
            }
        }
        return (30 * (max - min)) / 256;
    };
    IFlyBase.prototype.startRecoder = function () {
        var _this = this;
        if (this.recorder.isrecording) {
            this.recorder.resume();
        }
        else {
            this.recorder
                .start()
                .then(function () {
                console.log('开始录音');
                _this.drawRecord();
            }, function (error) {
                _this.emit(IFlyBase.BLOCK, error);
                console.log("\u5F02\u5E38\u4E86," + error.name + ":" + error.message);
            })
                .catch(function () {
                console.log('录音错误,error');
            });
        }
    };
    IFlyBase.prototype.counterDown = function () {
        var _this = this;
        if (this.counterDownTime === 60) {
            this.stop();
        }
        else if (this.counterDownTime > 60) {
            this.reset();
            return false;
        }
        this.counterDownTime++;
        this.counterDownTimeout = setTimeout(function () {
            _this.counterDown();
        }, 1000);
    };
    IFlyBase.prototype.reset = function () {
        this.counterDownTime = 0;
        clearTimeout(this.counterDownTimeout);
    };
    IFlyBase.SOCKET_OPEN = 'socket_open';
    IFlyBase.SOCKET_ERROR = 'socket_error';
    IFlyBase.SOCKET_CLOSE = 'socket_close';
    IFlyBase.SOCKET_MESSAGE = 'socket_message';
    IFlyBase.MESSAGE = 'message';
    IFlyBase.CODE_ERROR = 'code_error';
    IFlyBase.WAVE = 'wave';
    IFlyBase.BLOCK = 'block';
    IFlyBase.BYTE_LENGTH = 4 * 1280;
    return IFlyBase;
}(events_1.EventEmitter));
exports.IFlyBase = IFlyBase;
//# sourceMappingURL=IFlyBase.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/limi-lib/dist/lib/limi/audio/IFlyBase.js
// module id = tUJr
// module chunks = 0